var play_icon_default = {
  "shadow": "H1H2r",
  "playIcon": "JSdje"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
